import { render, staticRenderFns } from "./ReviewStageTournament.vue?vue&type=template&id=6bcefbee&scoped=true"
import script from "./ReviewStageTournament.vue?vue&type=script&lang=js"
export * from "./ReviewStageTournament.vue?vue&type=script&lang=js"
import style0 from "./ReviewStageTournament.vue?vue&type=style&index=0&id=6bcefbee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcefbee",
  null
  
)

export default component.exports